import { usePatternFormat } from 'react-number-format'

import { MaskedText } from '../baseInputs'

type Props = {
  label?: string
  name?: string
  helper?: string
  optional?: boolean
}

const DateMask = ({
  label: inputLabel,
  name: inputName,
  optional,
  helper,
  ...rest
}: Props) => {
  const name = inputName || 'date'
  const label = inputLabel || 'Date'

  const { format } = usePatternFormat({
    format: '##/##/####',
    mask: ['_'],
  })

  return (
    <MaskedText
      format={format}
      name={name}
      label={label}
      optional={optional}
      helper={helper}
      {...rest}
    />
  )
}

export default DateMask
